import { useQuery } from "react-query";
import { QUERY } from "../../constants/query";
import { useApiService } from "../useApiService";
import { SuperUserControllerService } from "../../services";

export const useGetAllFeedbacks = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_FEEDBACKS];

  const query = useQuery(queryKey, () =>
    handleRequest(
      SuperUserControllerService.superUserControllerGetAllFeedbacks()
    )
  );

  return {
    ...query,
  };
};

export const useGetAllUsers = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_USERS];

  const query = useQuery(queryKey, () =>
    handleRequest(SuperUserControllerService.superUserControllerGetAllUsers())
  );

  return {
    ...query,
  };
};

export const useGetAllPropertiesList = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_PROPERTIES_LIST];

  const query = useQuery(queryKey, () =>
    handleRequest(
      SuperUserControllerService.superUserControllerGetAllProperties()
    )
  );

  return {
    ...query,
  };
};
